export const isVaultFlowType = (flow: unknown): flow is paypal.FlowType =>
  flow === 'vault'
